export default [{"url":"https://workday-0.api.invexerp.io","name":"Branch 1","port":"6526","isStore":true,"isHQ":true}]